module.exports = __webpack_public_path__ + "img/product9.768bc25f.jpg";